import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useBreadcrumbStore = defineStore('breadcrumb', () => {
  const dynamicTitle = ref(null)
  function setTitle(title) { dynamicTitle.value = title || null }
  function clearTitle() { dynamicTitle.value = null }
  return { dynamicTitle, setTitle, clearTitle }
})
